import { render, staticRenderFns } from "./LayerLegend.vue?vue&type=template&id=b30b4262&scoped=true"
import script from "./LayerLegend.vue?vue&type=script&lang=ts"
export * from "./LayerLegend.vue?vue&type=script&lang=ts"
import style0 from "./LayerLegend.vue?vue&type=style&index=0&id=b30b4262&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30b4262",
  null
  
)

export default component.exports